import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from '@tanstack/react-query';

import { checkoutApi } from 'src/api';
import { GetWalletResponse } from 'src/types/api';
import { PaymentMethod, PaymentMethodStatus } from 'src/types/dto';

export const getWallet = () =>
  checkoutApi.get<GetWalletResponse>('wallet').then(res => res.data);

const getWalletById = (id: string) =>
  checkoutApi.get<PaymentMethod>(`wallet/${id}`).then(res => res.data);

const getWalletByIdThrowable = async (id: string) => {
  const response = await getWalletById(id);
  if (response.status === PaymentMethodStatus.WaitingPayment)
    throw new Error('Pagamento aguardando confirmação');
  return response;
};

export const useCheckoutWalletByIdQuery = (walletId: string) => {
  return useQuery<PaymentMethod, Error>({
    queryKey: ['wallet', walletId],
    queryFn: () => getWalletById(walletId),
  });
};

export const useCheckoutWalletByIdMutation = (
  options?: UseMutationOptions<PaymentMethod, Error, string>,
) => {
  return useMutation({ mutationFn: getWalletByIdThrowable, ...options });
};
